import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  background: #fff;
  min-height: 100vh;
`;

export const Header = styled.div`
  margin-bottom: 30px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #203b34;
  margin: 0 0 5px 0;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: #666;
`;

export const LegendContainer = styled.div`
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
`;

export const LegendTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #203b34;
  margin-bottom: 10px;
`;

export const LegendItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendColor = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

export const LegendLabel = styled.span`
  font-size: 13px;
  color: #333;
`;

export const CalendarSection = styled.div`
  margin-bottom: 30px;
`;

export const CalendarTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #203b34;
  margin-bottom: 15px;
`;

export const Calendar = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
`;

export const CalendarHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
`;

export const DayHeader = styled.div`
  padding: 10px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #203b34;
  border-right: 1px solid #e0e0e0;

  &:last-child {
    border-right: none;
  }
`;

export const CalendarBody = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
`;

export const DayCell = styled.div`
  min-height: 80px;
  padding: 8px;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  background: ${(props) => (props.isCurrentMonth ? "#fff" : "#fafafa")};

  &:nth-child(7n) {
    border-right: none;
  }
`;

export const DayNumber = styled.div`
  font-size: 13px;
  color: ${(props) => (props.isCurrentMonth ? "#203b34" : "#999")};
  margin-bottom: 5px;
  font-weight: 500;
`;

export const DayContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ParcelBar = styled.div`
  height: 4px;
  background-color: ${(props) => props.color};
  border-radius: 2px;
  width: ${(props) => props.percentage}%;
`;

export const ParcelHours = styled.div`
  font-size: 10px;
  color: #666;
  margin-top: 2px;
`;

export const WorkPartsSection = styled.div`
  margin-top: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
`;

export const WorkPartsTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #203b34;
  margin-bottom: 0;
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const WorkPartsCount = styled.span`
  font-size: 14px;
  font-weight: normal;
  color: #666;
  margin-left: 10px;
`;

export const WorkPartsList = styled.div`
  height: 650px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const WorkPartCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
  transition: background-color 0.2s;

  &:hover {
    background-color: #fafafa;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const WorkPartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const WorkPartName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #203b34;
`;

export const WorkPartStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => {
    if (props.status === 1) return "#ff9800"; // Pending
    if (props.status === 2) return "#4caf50"; // Completed
    if (props.status === 3) return "#ff9800"; // In Progress
    return "#666";
  }};

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: currentColor;
  }
`;

export const WorkPartInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InfoLabel = styled.span`
  font-size: 12px;
  color: #666;
  font-weight: 500;
  min-width: 100px;
`;

export const InfoValue = styled.span`
  font-size: 13px;
  color: #333;
  font-weight: 500;
`;

export const ParcelBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
`;

export const ParcelBadge = styled.span`
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  background-color: ${(props) => props.color};
  color: #fff;
  font-weight: 500;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 0.8fr 1fr;
  gap: 15px;
  padding: 12px 20px;
  background: #203b34;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const TableHeaderCell = styled.div`
  text-align: left;
`;

export const HoursBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 40px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: #203b34;
  color: #fff;
`;

export const WorkPartCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CellLabel = styled.div`
  font-size: 11px;
  color: #999;
`;

export const CellValue = styled.div`
  font-size: 13px;
  color: #333;
  font-weight: 500;
`;

export const MainLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(420px, 1.7fr) minmax(260px, 1fr) minmax(
      320px,
      1.2fr
    );
  gap: 20px;
  align-items: start;

  @media (max-width: 1400px) {
    grid-template-columns: minmax(360px, 1.5fr) minmax(240px, 0.9fr) minmax(
        280px,
        1fr
      );
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const CenterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 100%;
`;

export const StatsCard = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const StatsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #666;
`;

export const StatsIcon = styled.span`
  font-size: 16px;
`;

export const StatsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StatsItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const StatsLabel = styled.div`
  font-size: 13px;
  color: #333;
`;

export const StatsValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #203b34;
`;

export const BigStatsValue = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: #f9ae17;
  text-align: center;
  margin: 10px 0;
`;

export const BigStatsLabel = styled.div`
  font-size: 12px;
  color: #999;
  text-align: center;
`;

export const StatusDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-right: 8px;
  display: inline-block;
`;
